import { SORT_DATA } from './../../constants/sort.constants';
import { Sort, Columna, DataTable } from './../../interfaces/datatable.interface';
import { Component, Input, OnInit, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-datatable-sort-lista',
  templateUrl: './datatable-sort-lista.component.html',
  styleUrls: ['./datatable-sort-lista.component.scss']
})
export class DatatableSortListaComponent implements OnInit {
  @Input() datatable: DataTable;
  @Input() sorts: Sort[] = [];
  @Output() onSortCambiados = new EventEmitter<Sort[]>();

  sortData;

  constructor() {
    this.sortData = SORT_DATA;
  }

  ngOnInit(): void {
    // console.log('sorts: ', this.sorts);
  }

  isAsc(sort: Sort): boolean {
    return sort.sort === SORT_DATA.ASC;
  }

  sortClickeado(col: Columna, clazz: string) {
    if (!col.sort) {
      return;
    }
    const index = this.sorts.findIndex(sort => sort.key === col.sortKey);
    if (clazz === SORT_DATA.CLASS_NONE && index !== -1) {
      this.sorts.splice(index, 1);
      this.sortCambiados();
    } else {
      const sort = clazz === SORT_DATA.CLASS_ASC ? SORT_DATA.ASC : SORT_DATA.DESC;
      if (index !== -1) {
        this.sorts[index].sort = sort;
        this.sortCambiados();
      } else if (this.puedeAgregarseUnSort()) {
        this.sorts.push({ key: col.sortKey, sort, columna: col });
        this.sortCambiados();
      } else if (!this.puedeAgregarseUnSort()) {
        this.sorts.shift();
        this.sorts.push({ key: col.sortKey, sort, columna: col });
        this.sortCambiados();
      }
    }
  }

  hasToShow(col: Columna, clazz: string): boolean {
    const filtered = this.sorts.filter(s => s.key === col.sortKey);
    if (filtered.length === 0) {
      if (clazz === SORT_DATA.CLASS_ASC || clazz === SORT_DATA.CLASS_DESC) {
        return true;
      }
    } else {
      if (filtered[0].sort === SORT_DATA.ASC && clazz !== SORT_DATA.CLASS_ASC) {
        return true;
      }
      if (filtered[0].sort === SORT_DATA.DESC && clazz !== SORT_DATA.CLASS_DESC) {
        return true;
      }
    }
    return false;
  }

  puedeAgregarseUnSort(): boolean {
    return !this.datatable.sortMaximos || this.datatable.sortMaximos > this.sorts.length;
  }

  sortCambiados() {
    this.onSortCambiados.emit(this.sorts);
  }
}
